<template>
    <!-- 1.all-container-start -->
    <div class="all-container">

        <!-- 1.tabbar-container-start -->
        <tabbar :tabbarIndex="5"></tabbar>
        <!-- 1.tabbar-container-end -->

        <!-- 2.main-container-start -->
        <div class="main">
            <div class="top">
                <span class="text">物流详情</span>
                <div class="sj"></div>
            </div>
            <div class="bottom borderShadow">
                <div class="info">
                    <div class="top">物流信息</div>
                    <div class="bottom" v-if="Traces.length>0">
                        <div class="line flexStyle2" v-for="(item, index) of Traces" :key="index">
                            <div class="item flexStyle2">
                                <div class="left">物流状态:</div>
                                <div class="right right1">{{ item.AcceptStation || '暂无'}}</div>
                            </div>
                            <div class="item flexStyle2">
                                <div class="left">物流时间:</div>
                                <div class="right">{{ item.AcceptTime || '1970-01-01 12:00:00'}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="bottom" v-else>
                        <div class="line flexStyle2">
                            <div class="item flexStyle2">
                                <div class="left">暂无物流状态</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 2.main-container-end -->

        <!-- 100.footer-container-start -->
        <c-footer></c-footer>
        <!-- 100.footer-container-end -->
        
    </div>
    <!-- 1.all-container-end -->
</template>

<script>
import tabbar from '../../components/tabbar/tabbar';
import footer from '../../components/footer/footer';

export default {
    data(){                                      // 1.data
        return {
            currentPageInfo: {},                 // 1.1.currentPageInfo
            Traces: [],                          // 1.2.物流信息
        }
    },
    
    components: {                                // 2.components
        tabbar,                                  // 2.1.tabbar
        cFooter: footer,                         // 2.2.footer
    },

    methods: {                                   // 3.methods
    },

    mounted(){
        this.currentPageInfo = JSON.parse(decodeURIComponent(this.$route.query.obj));
        this.Traces = this.currentPageInfo.Traces || [];
    }

    
}
</script>

<style scoped lang="scss">
@import './trackInfo.scss';
</style>